var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartphoneError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54469C"
    },
    d: "M339.444,504.5H75.095c-7.738,0-14.011-6.273-14.011-14.011V71.516 c0-7.738,6.273-14.011,14.011-14.011h264.35c7.738,0,14.011,6.273,14.011,14.011v418.972 C353.456,498.227,347.183,504.5,339.444,504.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#463B84"
    },
    d: "M342.881,57.505h-19.603c7.738,0,14.011,6.273,14.011,14.011v418.972 c0,7.738-6.273,14.011-14.011,14.011h19.603c7.738,0,14.011-6.273,14.011-14.011V71.516 C356.892,63.778,350.619,57.505,342.881,57.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M112.862,57.505H75.095c-7.738,0-14.011,6.273-14.011,14.011v418.972c0,7.738,6.273,14.011,14.011,14.011h267.786 c7.738,0,14.011-6.273,14.011-14.011V71.516c0-7.738-6.273-14.011-14.011-14.011H141.862"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE2DF"
    },
    d: "M229.189,98.814L229.189,98.814c-1.646,7.276-8.112,12.442-15.571,12.442h-9.26 c-7.46,0-13.925-5.166-15.571-12.442v0c-1.646-7.276-8.112-12.442-15.571-12.442H96.106c-4.274,0-7.739,3.465-7.739,7.739v373.782 c0,4.274,3.465,7.739,7.739,7.739h222.399c4.274,0,7.739-3.465,7.739-7.739V94.111c0-4.274-3.465-7.739-7.739-7.739h-73.745 C237.301,86.372,230.835,91.538,229.189,98.814z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC4C8"
    },
    d: "M321.87,86.372h-20.303c4.274,0,7.739,3.465,7.739,7.739v373.782c0,4.274-3.465,7.739-7.739,7.739 h20.303c4.274,0,7.739-3.465,7.739-7.739V94.111C329.609,89.837,326.144,86.372,321.87,86.372z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M270.469,475.633h51.401c4.274,0,7.739-3.465,7.739-7.739V94.111c0-4.274-3.465-7.739-7.739-7.739h-77.109 c-7.46,0-13.925,5.166-15.571,12.442v0c-1.646,7.276-8.112,12.441-15.571,12.441h-9.26c-7.46,0-13.925-5.166-15.571-12.442 c-1.646-7.276-8.112-12.442-15.571-12.442H96.106c-4.274,0-7.739,3.465-7.739,7.739v373.782c0,4.274,3.465,7.739,7.739,7.739 h145.363"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF94D6"
    },
    d: "M274.429,119.278l1.652,4.017l9.468,15.853c0,0,19.156,10.349,20.697,11.89 c1.542,1.541,29.945,24.22,31.486,26.422c1.541,2.202,49.101,0,49.101,0l34.569-47.613c0,0,11.89-45.085,11.89-47.287 s-7.266-32.367-7.266-32.367l-18.275-26.862l-20.642-11.147l-11.069-3.478l0,0c-4.784-0.789-9.693-1.206-14.7-1.206 c-49.519,0-89.662,40.143-89.662,89.662C271.677,104.794,272.634,112.203,274.429,119.278L274.429,119.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF74C9"
    },
    d: "M376.039,8.706c23.131,13.283,38.723,38.213,38.723,66.8c0,42.525-34.473,76.998-76.998,76.998 c-26.261,0-49.438-13.156-63.335-33.227c9.849,38.823,45.024,67.546,86.91,67.546c49.519,0,89.662-40.143,89.662-89.662 C451.001,52.65,418.564,15.721,376.039,8.706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M447.442,72.11c-4.071-14.04-11.636-27.281-22.703-38.349c-35.015-35.015-91.786-35.015-126.801,0s-35.015,91.786,0,126.801 s91.786,35.015,126.801,0c16.546-16.546,25.269-37.95,26.177-59.621"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 391.232,
    y1: 67.269,
    x2: 331.446,
    y2: 127.055
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 391.232,
    y1: 127.055,
    x2: 331.446,
    y2: 67.269
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 171.667,
    y1: 220.239,
    x2: 171.667,
    y2: 234.11
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 246.309,
    y1: 220.239,
    x2: 246.309,
    y2: 234.11
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M165.821,285.676c28.778-14.205,57.556-14.205,86.334,0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneError);
export default __webpack_public_path__ + "static/media/smartphoneError.4b0e4db28e290f887de0325ce6589d1b.svg";
export { ForwardRef as ReactComponent };